import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "@/app/globals.css";
import { cleanupLegacyServiceWorkers, registerAppServiceWorker } from "@/lib/pwa-bootstrap";
import { App } from "./App";
import { InvoicePortalPage } from "./InvoicePortal";

const isInvoicePortal =
  typeof window !== "undefined" && window.location.hash.startsWith("#invoice-portal");

const rootEl = document.getElementById("root")!;

async function bootstrap() {
  if (await cleanupLegacyServiceWorkers()) {
    window.location.reload();
    return;
  }

  if (!isInvoicePortal) {
    await registerAppServiceWorker();
  }

  if (isInvoicePortal) {
    createRoot(rootEl).render(
      <StrictMode>
        <InvoicePortalPage />
      </StrictMode>,
    );
  } else {
    createRoot(rootEl).render(
      <StrictMode>
        <HashRouter
          basename={(() => {
            const b = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");

            return b === "" || b === "/" ? undefined : b;
          })()}
        >
          <App />
        </HashRouter>
      </StrictMode>,
    );
  }
}

void bootstrap();
